<template>
  <div class="mapcontainer">

    <router-link v-tooltip="{ content: localization('app-compare-map', 'Compare Map'), placement: 'top-center' }"
      style="border-radius: 8px; border: 0" :to="{ name: 'map-compare' }" tag="a"
      class="compare-icon has-text-white is-small">
      <img src="@/assets/icons/compare.svg" />
      <!-- <span class="is-semibold-12-500-14">Compare Maps</span> -->
    </router-link>
    <div id="map"></div>
    <div v-if="is_popup_active">
      <b-modal size="lg" :active="is_popup_active" @close="is_popup_active = false" scrollable>
        <RawImageMapModal :raw_images="raw_images" />
      </b-modal>
    </div>
    <popup @close="popup_feature = null" :feature="popup_feature"></popup>
    <Publish v-if="$store.getters.therm_v2 && $store.getters.show_publish" />
    <!-- load template -->
    <a class="load-template-btn" id="load-template" :style="{ right: popup_feature ? '19.8rem' : '13rem' }"
      v-if="selected_features && selected_features.length"
      v-tooltip="{ content: localization('app-load-from-template', 'Load from Template'), placement: 'bottom-center' }">
      <img src="@/assets/icons/load-template-light.svg" alt srcset />
    </a>

    <a id="btn-edit" v-if="selected_features && selected_features.length > 1" class="load-template-btn button is-small"
      :style="{ right: popup_feature ? '22.5rem' : '15.5rem' }" v-tooltip="{
        content: localization('app-edit', 'Edit'),
        placement: 'bottom-center',
      }">
      <!-- <img v-if="active_button == 2" src="../../assets/icons/edit-active.svg" alt srcset /> -->
      <img src="../../assets/icons/edit.svg" alt srcset />
    </a>
    <hot-table-edit-feature></hot-table-edit-feature>


    <AddTablesToView />
    <template>
      <a @click="TOGGLE_FLY_STATE(!fly_active)" class="fly_toggle"
        v-tooltip="{ content: localization('app-toggle-fly', 'Toggle Fly') }">
        <img v-if="fly_active" src="@/assets/icons/fly-active.svg" />
        <img v-else src="@/assets/icons/fly-inactive.svg" />
      </a>
    </template>
    <template>
      <a @click="toggle_labels()" class="toggle_labels"
        v-tooltip="{ placement: 'bottom-center', content: localization('app-toggle-labels', 'Toggle labels') }">
        <i class="fa fa-tag" :class="{ 'has-text-info': display_labels, 'has-text-black': !display_labels }"></i>
      </a>
    </template>
    <div @click="toggle_marker()" class="map-marker is-pointer" style="
        position: fixed;
        right: 10.1rem;
        top: 1.4rem;
        z-index: 38;
        width: 14px;
      ">
      <!-- <i class="fa fa-map" :class="{ 'has-text-info': map_marker_active }"></i> -->
    </div>
    <div class="bg-panel"></div>
    <sidebar :mapstyle="mapstyle" @sidebar="sidebar_active = $event"></sidebar>
    <p @click="toggle_mapstyle" class="map_style is-pointer" :style="{ left: sidebar_active ? '23rem' : '3.6rem' }"
      v-tooltip="{ content: mapstyle == 'satellite' ? localization('app-street', 'Street') : localization('app-statellite', 'Satellite') }">
      <img v-if="mapstyle == 'street'" src="@/assets/satellite.jpg" />
      <img v-else src="@/assets/street.jpg" />
    </p>
  </div>
  <!-- <div id="map" @keydown="onkeydown($event)"></div> -->
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import RawImageMapModal from "./components/popup-modal.component";
import AddTablesToView from "../../components/add-tables-to-view/add-tables-to-view.component";
import Popup from "./components/popup.component";
import axios from "axios";
import SidebarComponent from "@/components/sidebar/sidebar.component";
import Publish from "../publish";
import APIService from "@/api.service";
const apiService = new APIService();
import HotTableEditFeature from "./components/hot-table-edit-features";

// import { httpClient } from "@/http-client";
export default {
  data() {
    return {
      display_labels: false,
      toast: null,
      map_marker_active: false,
      sidebar_active: true,
      raw_images: [],
      is_popup_active: false,
      popup_feature: null,
    };
  },
  components: {
    popup: Popup,
    RawImageMapModal,
    AddTablesToView,
    sidebar: SidebarComponent,
    Publish,
    HotTableEditFeature,
  },
  watch: {
    cluster_active_layer: {
      handler(val) {
        if (this.cluster_active_layer && !this.active_layers[this.cluster_active_layer.projectUid].project_details) {
          apiService
            .get_project_details({
              group_id: this.cluster_active_layer.groupUid,
              id: this.cluster_active_layer.projectUid,
            })
            .then((res) => {
              let project_details = res.data;
              if (_.isString(project_details.element)) {
                apiService.get_element({ url: project_details.element }).then((element) => {
                  project_details.element = element.data;
                  let active_layers = { ...this.active_layers };
                  active_layers[this.cluster_active_layer.projectUid]["project_details"] = project_details;
                  this.$store.commit("UPDATE_ACTIVE_LAYERS", active_layers);
                });
              } else {
                let active_layers = { ...this.active_layers };
                active_layers[this.cluster_active_layer.projectUid]["project_details"] = res.data;
                this.$store.commit("UPDATE_ACTIVE_LAYERS", active_layers);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      },
      immediate: true,
    },
    popup_feature: {
      handler(n, o) {
        // console.log(n,o)
        if (n !== o) {
          parent.postMessage(
            {
              name: "change_icons_position",
              details_open: this.popup_feature && this.popup_feature.type ? true : false,
            },
            "*"
          );
        }
      },
    },
  },
  async mounted() {
    this.$root.$on("is_popup_active", (raw_images) => {
      this.raw_images = raw_images;
      this.is_popup_active = true;
    });
    this.$root.$on("create-project-ticket-completed", () => {
      this.map_marker_active = false;
      if (this.map.getLayer("mapMarker")) this.map.setLayoutProperty("mapMarker", "visibility", "none");
    });
    await this.init_map();
    this.map.on("style.load", () => {
      this.INIT_FEATURE_COLORS(this.stops);
    });
    this.map.on("load", () => {
      if (localStorage.getItem("mapstyle") == "street") {
        this.map.setStyle("mapbox://styles/mapbox/streets-v11");
      }
      this.INIT_DRAW(this.init_draw());
      this.map.addControl(new mapboxgl.NavigationControl(), "top-right");
      this.map.addControl(this.draw);
      this.$store
        .dispatch("get_vectors", this.$route.params.uid)
        .then((res) => {
          let vectors = {};
          res.data.forEach((c) => (vectors[c.class_id] = { ...c, count: 0 }));
          this.INIT_VECTORS(vectors);
          this.INIT_FEATURE_COLORS(this.stops);
        })
        .catch((err) => {
          this.handleErrors(err);
          console.log("err");
        });
    });
    this.map.on("draw.selectionchange", (e) => {
      if (e.features.length === 1 && e.features[0].properties.class_name !== "table") {
        this.popup_feature = e.features[0];
      } else {
        this.popup_feature = null;
      }
    });
    this.map.on("draw.selectionchange", (e) => {
      this.SET_SELECTED_FEATURES(e.features);
    });
    this.map.on("draw.create", (e) => {
      this.UPDATE_VECTOR_COUNT();
    });
    this.map.on("click", (e) => {
      // this.SET_SELECTED_FEATURES(e.features);
      this.add_marker(e);
    });
    this.map.on("draw.update", (e) => {
      this.UPDATE_VECTOR_COUNT();
      this.revert_non_editable_features();
    });
  },
  computed: {
    ...mapState([
      "token",
      "api_host",
      "map",
      "draw",
      "vectors",
      "active_layer",
      "features",
      "selected_features",
      "fly_active",
      "cluster_active_layer",
      "active_layers",
    ]),
    mapstyle: {
      get() {
        return this.$store.state.mapstyle;
      },
      set(val) {
        this.$store.commit("SET_MAPSTYLE", val);
      },
    },
    stops() {
      let arr = [];
      Object.values(this.vectors).forEach((v) => {
        arr.push([v.class_id, v.color]);
      });
      return arr;
    },
  },
  created() {
    document.addEventListener("click", (event) => {
      if (event.target.id == "load-template" || (event.target.parentNode && event.target.parentNode.id == "load-template")) {
        if (this.draw.getSelected().features.length) {
          parent.postMessage(
            {
              name: "tickets-bulk-create",
              features: this.draw.getSelected().features,
            },
            "*"
          );
        }
      }
    });
  },
  methods: {
    ...mapMutations([
      "UPDATE_VECTOR_COUNT",
      "INIT_MAP",
      "INIT_DRAW",
      "INIT_VECTORS",
      "INIT_FEATURE_COLORS",
      "SET_SELECTED_FEATURES",
      "SET_MAPBOX_TOKEN",
      "TOGGLE_FLY_STATE",
    ]),
    toggle_labels() {
      try {
        this.display_labels = !this.display_labels;
        if (this.map) {
          if (this.map.getLayer("features_labels")) this.map.removeLayer("features_labels");
          if (this.map.getSource("features_labels")) this.map.removeSource("features_labels");
        }
        this.map.loadImage("/img/icons/mapbox-text-bg.png", (error, image) => {
          if (error) throw error;
          if (!this.map.hasImage("mapbox-text-bg")) {
            this.map.addImage("mapbox-text-bg", image, {});
          }

          if (this.display_labels) {
            let source = this.map.getSource("features_labels");
            let featureCollection = this.draw.getAll();
            featureCollection.features = featureCollection.features.filter((f) => f.properties.string_number);

            if (source) {
              source.setData(featureCollection);
            } else {
              this.map.addSource("features_labels", {
                type: "geojson",
                data: featureCollection,
              });
            }
            let layer = this.map.getLayer("features_labels");
            if (!layer) {
              this.map.addLayer({
                id: "features_labels",
                type: "symbol",

                source: "features_labels",
                paint: {
                  "text-color": "#202",
                },
                layout: {
                  "icon-size": 1.2,
                  "icon-image": "mapbox-text-bg",
                  "icon-text-fit": "both",
                  "text-justify": "center",
                  "text-anchor": "center",
                  "text-field": ["get", "string_number"],
                  "text-font": ["literal", ["Arial Unicode MS Regular"]],
                  "text-size": 10,
                },
              });
            }
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    toggle_mapstyle() {
      if (this.mapstyle.includes("street")) {
        this.mapstyle = "satellite";
        this.map.setStyle("mapbox://styles/mapbox/satellite-v8");
      } else {
        this.mapstyle = "satellite";
        this.map.setStyle("mapbox://styles/mapbox/streets-v11");
        this.mapstyle = "street";
      }
    },
    async add_marker_layer() {
      if (!this.map.hasImage("mapMarker")) {
        this.map.loadImage("/img/icons/map-marker.png", async (error, image) => {
          if (error) {
            console.log("Imaage exists");
            //   throw error
          } else {
            this.map.addImage("mapMarker", image);
          }
        });
      }
      if (!this.map.getSource("mapMarker")) {
        await this.map.addSource("mapMarker", {
          type: "geojson",
          data: { type: "FeatureCollection", features: [] },
        });
      }
      if (!this.map.getLayer("mapMarker")) {
        await this.map.addLayer({
          id: "mapMarker",
          type: "symbol",
          source: "mapMarker",
          layout: {
            "icon-image": "mapMarker",
            "icon-size": 1,
          },
        });
      }
    },
    toggle_marker() {
      this.map_marker_active = !this.map_marker_active;
      if (this.map_marker_active) {
        this.toast = this.$toast.open({
          duration: 1000000,
          message: this.localization("app-tap-anywhere-to-add-task", "Tap anywhere on the map to add a ticket."),
          position: "is-top",
        });
      } else {
        this.toast.close();
        this.map.setLayoutProperty("mapMarker", "visibility", "none");
        parent.postMessage(
          {
            name: "create-project-ticket",
            element: null,
          },
          "*"
        );
      }
    },
    add_marker(e) {
      this.add_marker_layer();
      if (this.map_marker_active && e) {
        if (this.toast) this.toast.close();
        setTimeout(() => {
          if (this.map.getLayer("mapMarker")) this.map.setLayoutProperty("mapMarker", "visibility", "visible");
          console.log("active layer", this.active_layers[this.cluster_active_layer.projectUid]);
          parent.postMessage(
            {
              open_on_create: true,
              name: "create-project-ticket",
              element: {
                ...this.active_layers[this.cluster_active_layer.projectUid].project_details.element,
                centroid: e.lngLat,
              },
            },
            "*"
          );
        }, 300);

        this.map.getSource("mapMarker").setData({
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: Object.values(e.lngLat),
              },
            },
          ],
        });
      } else {
        this.toast = null;
        if (this.map.getLayer("mapMarker")) this.map.setLayoutProperty("mapMarker", "visibility", "none");
      }
    },
    async init_map() {
      let res, token;
      try {
        // doesn't work with org appended in url
        // res = await httpClient({
        //     url: "https://sensehawk-config.s3.ap-south-1.amazonaws.com/mapbox-gl-token.json",

        // })
        res = await axios.get("https://sensehawk-config.s3.ap-south-1.amazonaws.com/mapbox-gl-token.json");
        token = res.data.token;
        this.SET_MAPBOX_TOKEN(token);
      } catch (err) {
        token = null;
      }

      if (!token) mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
      else mapboxgl.accessToken = token;

      this.INIT_MAP(
        new mapboxgl.Map({
          container: "map",
          style: "mapbox://styles/mapbox/satellite-v8",
          center: [-122.0350127, 37.2805218],
          zoom: 0,
          maxZoom: 24,
          attributionControl: false,
        })
      );
    },
    init_draw() {
      return new MapboxDraw({
        keybindings: false,
        userProperties: true,
        displayControlsDefault: false,
      });
    },
    revert_non_editable_features() {
      if (this.selected_features && this.selected_features.length)
        for (let feature of this.selected_features) {
          // if (feature.properties.editable===false)
          this.draw.add(feature);
        }
    },
  },
};
</script>
<style lang="scss">
#map {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.mapboxgl-ctrl-top-right .mapboxgl-ctrl {
  margin: 16px 16px 0 0;
}

.compare-icon {
  position: absolute;
  z-index: 100;
  bottom: 3.5rem;
  right: 1rem;
}

.fly_toggle {
  position: fixed;
  top: 1.2rem;
  right: 4.2rem;
  z-index: 30 !important;
  transform: rotate(-90deg);
}

.toggle_labels {
  position: fixed;
  padding: 6px 10px;
  bottom: 1rem;
  right: 7.8rem;
  z-index: 30 !important;
  background-color: white;
  border-radius: 0.2rem;
  box-shadow: 0 1px 3px 0 rgba(8, 8, 8, 0.3);

}

.load-template-btn {
  position: fixed;
  top: 1rem;
  // right: 21rem;
  width: 2rem;
  height: 2rem;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(8, 8, 8, 0.3);
}

.bg-panel {
  position: fixed;
  top: 0.9rem;
  right: 3.8rem;
  width: 5rem;
  height: 2.1rem;
  background-color: white;
  border-radius: 0.2rem;
  box-shadow: 0 2px 2px 0 rgba(8, 8, 8, 0.3);
}

.map_style {
  position: fixed;
  bottom: 1rem;
  // left: 23rem;
  height: 3.5rem;
  border: 2px solid white;
  border-radius: 6px;

  img {
    border-radius: 6px;
  }

  z-index: 30 !important;
  transition: left 0.5s;
}
</style>
